import React from 'react';
import { dvtSearchColumns, vatTuSearchColumns } from '@/constants/search-columns';
import type { DonViTinh, GiaBanVatTuData } from '@/types/schemas';
import { FormField, SearchField } from '@/components/custom/erp';
import { useVatTuDvtOptions } from '../../hooks';
import { Label } from '@/components/ui/label';
import { QUERY_KEYS } from '@/constants';
import { FormMode } from '@/types/form';

interface BasicFormProps {
  mode: FormMode;
  vatTu: GiaBanVatTuData | null;
  donViTinh: DonViTinh | null;
  setVatTu: (vatTu: GiaBanVatTuData | null) => void;
  setDonViTinh: (donViTinh: DonViTinh | null) => void;
}

function BasicForm({ mode, vatTu, donViTinh, setVatTu, setDonViTinh }: BasicFormProps) {
  const isViewMode = mode === 'view';

  const { dvtOptions, handleVatTuSelection } = useVatTuDvtOptions({
    vatTu,
    setVatTu,
    donViTinh,
    setDonViTinh
  });

  return (
    <div className='space-y-3 p-6'>
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-32'>Mã vật tư</Label>
        <div>
          <SearchField<GiaBanVatTuData>
            displayRelatedField={'ten_vt'}
            columnDisplay={'ma_vt'}
            searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
            searchColumns={vatTuSearchColumns}
            dialogTitle='Danh mục vật tư'
            value={vatTu?.ma_vt || ''}
            relatedFieldValue={vatTu?.ten_vt || ''}
            onRowSelection={handleVatTuSelection}
            disabled={isViewMode}
          />
        </div>
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-32'>Đơn vị tính</Label>
        <div>
          <SearchField<DonViTinh>
            displayRelatedField={'ten_dvt'}
            columnDisplay={'dvt'}
            searchEndpoint={dvtOptions.length > 0 ? undefined : `/${QUERY_KEYS.DON_VI_TINH}/`}
            searchColumns={dvtSearchColumns}
            rows={dvtOptions}
            dialogTitle='Danh mục đơn vị tính'
            value={donViTinh?.dvt || ''}
            relatedFieldValue={donViTinh?.ten_dvt || ''}
            onRowSelection={setDonViTinh}
            disabled={isViewMode}
          />
        </div>
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-32'>Ngày hiệu lực</Label>
        <FormField type='date' name='ngay_hl' disabled={isViewMode} className='w-48' />
      </div>
    </div>
  );
}

export default BasicForm;
